import { QUILL_TAGS } from '@/utils/macros'

/** Class DecodeQuill */
export default class DecodeQuill {
    /**
     * Decode data from device to HTML code
     * @param data - encoded data
     * @returns {String} - HTML code
     */
    editor(data, device) {
        data = this.replace_html_tags_for_special_characters(data)
        let lines = this.getLines(data)
        for (let i = 0; i < lines.length; i++) {
            lines[i] = this.remove_unnecessary_tags(lines[i], '&8')
        }
        for (let i = 0; i < lines.length; i++) {
            lines[i] = this.remove_unnecessary_tags(lines[i], '&H')
        }
        if (device === 'cash_register') {
            lines = this.set_jpk_tags_for_cash_register(lines)
            lines = this.set_editing_tags_for_quill_cash_register(lines)
            lines = this.set_align_center_tag_for_quill_cash_register(lines)
        } else if (device === 'printer') {
            lines = this.set_jpk_tags_for_quill_printer(lines)
            lines = this.set_editing_tags_for_quill_printer(lines)
            lines = this.set_align_center_tag_for_printer(lines)
        }
        data = ''
        for (let line of lines) {
            let verify_value = line.slice(0, 27)
            if (verify_value !== '<p class="ql-align-center">') {
                data = data + '<p>' + line + '</p>'
            } else {
                data = data + line
            }
        }
        return this.prepareData(data)
    }
    set_jpk_tags_for_cash_register(lines) {
        let jpk_elements = {}
        for (let i = 0; i < lines.length; i++) {
            Object.keys(QUILL_TAGS.JPK_ENCODED).forEach(key => { // function which is setting jpk elements per line
                let first_element = QUILL_TAGS.JPK_ENCODED[key][0]
                let second_element = QUILL_TAGS.JPK_ENCODED[key][1]
                let regex = new RegExp(`[${first_element}][${second_element}]`, 'g')
                let result = lines[i].match(regex)
                if (result !== null) {
                    if (result.length === 1 && Object.keys(jpk_elements).includes(key)) { // there was already element with such key
                        jpk_elements[key]++
                            let index = lines[i].lastIndexOf(QUILL_TAGS.JPK_ENCODED[key])
                        let where_to_place_begining_tag = (index - lines[i].length) < 0 ? ((index - lines[i].length) * (-1)) - 2 : (index - lines[i].length) - 2 // -2 because there is no opening tag in the line
                        lines[i] =
                            lines[i].slice(0, where_to_place_begining_tag) +
                            `<${QUILL_TAGS.JPK_DECODED[key]}>` +
                            lines[i].slice(where_to_place_begining_tag, index) +
                            `</${QUILL_TAGS.JPK_DECODED[key]}>` +
                            lines[i].slice(index, lines[i].length)
                        lines[i] = lines[i].replace(QUILL_TAGS.JPK_ENCODED[key], '') // clear &1 from text
                        delete jpk_elements[key]
                    } else if (result.length === 1) {
                        Object.assign(jpk_elements, {
                                [key]: 1
                            }) // there is only one element in the line and we need to add opening and closing tag
                        let index = lines[i].indexOf(QUILL_TAGS.JPK_ENCODED[key])
                        let where_to_place_end_tag = (lines[i].length - index) > 0 ? (lines[i].length - index) : (lines[i].length - index) * (-1)
                        lines[i] =
                            lines[i].slice(0, index) +
                            `<${QUILL_TAGS.JPK_DECODED[key]}>` +
                            lines[i].slice(index, where_to_place_end_tag) +
                            `</${QUILL_TAGS.JPK_DECODED[key]}>` +
                            lines[i].slice(where_to_place_end_tag, lines[i].length)
                        lines[i] = lines[i].replace(QUILL_TAGS.JPK_ENCODED[key], '') // clear &1 from text
                    } else if (result.length === 2) {
                        Object.assign(jpk_elements, {
                            [key]: 2
                        })
                        lines[i] = lines[i].replace(QUILL_TAGS.JPK_ENCODED[key], `<${QUILL_TAGS.JPK_DECODED[key]}>`) // first replace with opening tag
                        lines[i] = lines[i].replace(QUILL_TAGS.JPK_ENCODED[key], `</${QUILL_TAGS.JPK_DECODED[key]}>`) // second replace with closing tag
                        delete jpk_elements[key]
                    }
                } else if (Object.keys(jpk_elements).includes(key)) { // that means there is no such element in the line but there was no closing tag yet in header
                    lines[i] = `<${QUILL_TAGS.JPK_DECODED[key]}>` + lines[i] + `</${QUILL_TAGS.JPK_DECODED[key]}>` // add special tags
                }
            })
        }
        return lines
    }

    set_jpk_tags_for_quill_printer(lines) {
        let jpk_elements = {}
        for (let i = 0; i < lines.length; i++) {
            Object.keys(QUILL_TAGS.JPK_ENCODED).forEach(key => { // function which is setting jpk elements per line
                let first_element = QUILL_TAGS.JPK_ENCODED[key][0]
                let second_element = QUILL_TAGS.JPK_ENCODED[key][1]
                let regex = new RegExp(`[${first_element}][${second_element}]`, 'g')
                let result = lines[i].match(regex)
                if (result !== null) {
                    if (result.length === 1 && Object.keys(jpk_elements).includes(key)) { // there was already element with such key
                        jpk_elements[key]++
                            // let index = lines[i].lastIndexOf(QUILL_TAGS.JPK_ENCODED[key])
                            // let where_to_place_begining_tag = (index - lines[i].length) < 0 ? ((index - lines[i].length) * (-1)) - 2 : (index - lines[i].length) - 2 // -2 because there is no opening tag in the line
                            lines[i] =
                            `<${QUILL_TAGS.JPK_DECODED[key]}>` +
                            lines[i].slice(0) +
                            `</${QUILL_TAGS.JPK_DECODED[key]}>`
                        lines[i] = lines[i].replace(QUILL_TAGS.JPK_ENCODED[key], '') // clear &TAG from text
                        delete jpk_elements[key]
                    } else if (result.length === 1) {
                        Object.assign(jpk_elements, {
                                [key]: 1
                            }) // there is only one element in the line and we need to add opening and closing tag
                        let index = lines[i].indexOf(QUILL_TAGS.JPK_ENCODED[key])
                            // let where_to_place_end_tag = (lines[i].length - index) > 0 ? (lines[i].length - index) : (lines[i].length - index) * (-1)
                        lines[i] =
                            lines[i].slice(0, index) +
                            `<${QUILL_TAGS.JPK_DECODED[key]}>` +
                            lines[i].slice(index, lines[i].length) +
                            `</${QUILL_TAGS.JPK_DECODED[key]}>`
                        lines[i] = lines[i].replace(QUILL_TAGS.JPK_ENCODED[key], '') // clear &1 from text
                    } else if (result.length === 2) {
                        Object.assign(jpk_elements, {
                            [key]: 2
                        })
                        lines[i] = lines[i].replace(QUILL_TAGS.JPK_ENCODED[key], `<${QUILL_TAGS.JPK_DECODED[key]}>`) // first replace with opening tag
                        lines[i] = lines[i].replace(QUILL_TAGS.JPK_ENCODED[key], `</${QUILL_TAGS.JPK_DECODED[key]}>`) // second replace with closing tag
                        delete jpk_elements[key]
                    }
                } else if (Object.keys(jpk_elements).includes(key)) { // that means there is no such element in the line but there was no closing tag yet in header
                    lines[i] = `<${QUILL_TAGS.JPK_DECODED[key]}>` + lines[i] + `</${QUILL_TAGS.JPK_DECODED[key]}>` // add special tags
                }
            })
        }
        return lines
    }

    set_editing_tags_for_quill_printer(lines) {
        let is_editing_tag_still_in_text = false
        do {
            for (let i = 0; i < lines.length; i++) {
                Object.keys(QUILL_TAGS.TEXT_EDITING_PRINTER).forEach(key => { // function which is setting editing tags elements per line
                    let first_element = QUILL_TAGS.TEXT_EDITING_PRINTER[key][0]
                    let second_element = QUILL_TAGS.TEXT_EDITING_PRINTER[key][1]
                    let regex = new RegExp(`[${first_element}][${second_element}]`, 'g')
                    let result = lines[i].match(regex) // we need to check matches
                    if (result !== null && result.length === 1) {
                        lines[i] =
                            `<${QUILL_TAGS.TEXT_EDITING_PRINTER_DECODED[key]}>` +
                            lines[i].slice(0) +
                            `</${QUILL_TAGS.TEXT_EDITING_PRINTER_DECODED[key]}>`
                        lines[i] = lines[i].replace(QUILL_TAGS.TEXT_EDITING_PRINTER[key], '')
                    } else if (result !== null && result.length >= 2) {
                        let first_index = lines[i].indexOf(QUILL_TAGS.TEXT_EDITING_PRINTER[key], 0)
                        let second_index = lines[i].indexOf(QUILL_TAGS.TEXT_EDITING_PRINTER[key], first_index + 1)
                            // let where_to_place_end_tag = (lines[i].length - index) > 0 ? (lines[i].length - index) : (lines[i].length - index) * (-1)
                        lines[i] =
                            lines[i].slice(0, first_index) +
                            `<${QUILL_TAGS.TEXT_EDITING_PRINTER_DECODED[key]}>` +
                            lines[i].slice(first_index, second_index) +
                            `</${QUILL_TAGS.TEXT_EDITING_PRINTER_DECODED[key]}>` +
                            lines[i].slice(second_index, lines[i].length)
                        lines[i] = lines[i].replace(QUILL_TAGS.TEXT_EDITING_PRINTER[key], '')
                        lines[i] = lines[i].replace(QUILL_TAGS.TEXT_EDITING_PRINTER[key], '')
                    }
                })
            }
            is_editing_tag_still_in_text = true
            for (let i = 0; i < lines.length; i++) {
                Object.keys(QUILL_TAGS.TEXT_EDITING_PRINTER).forEach(key => { // function which is setting editing tags elements per line
                    let first_element = QUILL_TAGS.TEXT_EDITING_PRINTER[key][0]
                    let second_element = QUILL_TAGS.TEXT_EDITING_PRINTER[key][1]
                    let regex = new RegExp(`[${first_element}][${second_element}]`, 'g')
                    let result = lines[i].match(regex) // we need to check matches
                    if (result !== null) {
                        is_editing_tag_still_in_text = false
                    }
                })
            }
        } while (is_editing_tag_still_in_text === false)
        return lines
    }

    set_editing_tags_for_quill_cash_register(lines) {
        let is_editing_tag_still_in_text = false
        do {
            for (let i = 0; i < lines.length; i++) {
                Object.keys(QUILL_TAGS.TEXT_EDITING_PRINTER).forEach(key => { // function which is setting editing tags elements per line
                    let first_element = QUILL_TAGS.TEXT_EDITING_PRINTER[key][0]
                    let second_element = QUILL_TAGS.TEXT_EDITING_PRINTER[key][1]
                    let regex = new RegExp(`[${first_element}][${second_element}]`, 'g')
                    let result = lines[i].match(regex)
                    if (result !== null) {
                        let first_index = lines[i].indexOf(QUILL_TAGS.TEXT_EDITING_PRINTER[key], 0)
                        let second_index = lines[i].indexOf(QUILL_TAGS.TEXT_EDITING_PRINTER[key], first_index + 1)
                        lines[i] =
                            lines[i].slice(0, first_index) +
                            `<${QUILL_TAGS.TEXT_EDITING_PRINTER_DECODED[key]}>` +
                            lines[i].slice(first_index, second_index) +
                            `</${QUILL_TAGS.TEXT_EDITING_PRINTER_DECODED[key]}>` +
                            lines[i].slice(second_index, lines[i].length)
                        lines[i] = lines[i].replace(QUILL_TAGS.TEXT_EDITING_PRINTER[key], '')
                        lines[i] = lines[i].replace(QUILL_TAGS.TEXT_EDITING_PRINTER[key], '')
                    }
                })
            }
            is_editing_tag_still_in_text = true
            for (let i = 0; i < lines.length; i++) {
                Object.keys(QUILL_TAGS.TEXT_EDITING_PRINTER).forEach(key => { // function which is setting editing tags elements per line
                    let first_element = QUILL_TAGS.TEXT_EDITING_PRINTER[key][0]
                    let second_element = QUILL_TAGS.TEXT_EDITING_PRINTER[key][1]
                    let regex = new RegExp(`[${first_element}][${second_element}]`, 'g')
                    let result = lines[i].match(regex)
                    if (result !== null) {
                        is_editing_tag_still_in_text = false
                    }
                })
            }
        } while (is_editing_tag_still_in_text === false)
        return lines
    }

    set_align_center_tag_for_quill_cash_register(lines) {
        for (let i = 0; i < lines.length; i++) {
            Object.keys(QUILL_TAGS.TEXT_EDITING_PRINTER_ALIGN).forEach(key => { // function which is setting editing tags elements per line
                let first_element = QUILL_TAGS.TEXT_EDITING_PRINTER_ALIGN[key][0]
                let second_element = QUILL_TAGS.TEXT_EDITING_PRINTER_ALIGN[key][1]
                let regex = new RegExp(`[${first_element}][${second_element}]`, 'g')
                let result = lines[i].match(regex)
                if (result !== null) {
                    lines[i] =
                        `<${QUILL_TAGS.TEXT_EDITING_PRINTER_ALIGN_DECODED[key]}>` +
                        lines[i].slice(0) +
                        `</p>`
                    lines[i] = lines[i].replace(QUILL_TAGS.TEXT_EDITING_PRINTER_ALIGN[key], '')
                    lines[i] = lines[i].replace(QUILL_TAGS.TEXT_EDITING_PRINTER_ALIGN[key], '')
                }
            })
        }
        return lines
    }

    set_align_center_tag_for_printer(lines) {
        for (let i = 0; i < lines.length; i++) {
            Object.keys(QUILL_TAGS.TEXT_EDITING_PRINTER_ALIGN).forEach(key => { // function which is setting editing tags elements per line
                let first_element = QUILL_TAGS.TEXT_EDITING_PRINTER_ALIGN[key][0]
                let second_element = QUILL_TAGS.TEXT_EDITING_PRINTER_ALIGN[key][1]
                let regex = new RegExp(`[${first_element}][${second_element}]`, 'g')
                let result = lines[i].match(regex)
                if (result !== null) {
                    lines[i] =
                        `<${QUILL_TAGS.TEXT_EDITING_PRINTER_ALIGN_DECODED[key]}>` +
                        lines[i].slice(0) +
                        `</p>`
                    lines[i] = lines[i].replace(QUILL_TAGS.TEXT_EDITING_PRINTER_ALIGN[key], '')
                    lines[i] = lines[i].replace(QUILL_TAGS.TEXT_EDITING_PRINTER_ALIGN[key], '')
                }
            })
        }
        return lines
    }
    remove_unnecessary_tags(data, pattern) {
        let counter = 0
        let result = null
        do {
            result = data.indexOf(pattern, counter)
            if (result !== -1 && data[result - 1] !== '&') {
                let array_of_chars = [...data]
                array_of_chars[result + 1] = ''
                array_of_chars[result] = ''
                data = array_of_chars.join('')
            }
            counter++
        } while (result !== -1)
        return data
    }

    replace_html_tags_for_special_characters(data) {
        data = data.replace(/\u003C/g, '&lt;') // replace html tag: <  for: &lt;
        data = data.replace(/\u003E/g, '&gt;') // replace html tag: > for: &gt;
        return data
    }

    /**
     * Cut data to lines
     * @param {string} data - encoded data
     * @returns {Array} - lines of data
     */
    getLines(data) {
        const lines = []
        while (data.indexOf(String.fromCharCode(10)) >= 0) {
            const endIndex = data.indexOf(String.fromCharCode(10))
            lines.push(data.substring(0, endIndex))
            data = data.substring(endIndex + 1, data.length)
        }
        if (data.length > 0) {
            lines.push(data)
        }
        return lines
    }

    /**
     * Prepare data for editor (replace encoded tags to encoded)
     * @param {String} data - encoded data
     * @returns {String} - decoded data (ready to display in editor)
     */
    prepareData(data) {
        const replace_empty_lines = new RegExp(/<p><\/p>/, 'g')
        const empty_line_replacement = '<p>&nbsp;</p>' // add empty space to display correctly in quill
        data = data.replace(replace_empty_lines, empty_line_replacement)
        return this.replaceExceptionTags(data, '&&', '&')
    }

    /**
     * Replace exception value in text
     * @param data - HTML data
     * @param search - exception value
     * @param replacement - new value
     * @returns {String} - data with new values
     */
    replaceExceptionTags(data, search, replacement) {
        return data.replace(new RegExp(search, 'g'), replacement)
    }
}

/*
SAME HEADERS SAMPLES FROM PRINTER AND CASH REGISTER AFTER READ (DIFFERENCES)

Nagłówek odczytany z drukarki:
&h&b&1aaaaaaaaaaaaaaaaaaaa
&h&baaaaaaaaaaaaaaaaaaaa&1
&212-250&2
&3orzyszu&3

Nagłówek odczytany z kasy:
&b&h&1aaaaaaaaaaaaaaaaaaaa&h&b
&b&haaaaaaaaaaaaaaaaaaaa&1&h&b
&212-250&2
&3orzyszu&3

Nagłówek wysłany do kasy:
&b&h&1aaaaaaaaaaaaaaaaaaaa&h&b
&b&haaaaaaaaaaaaaaaaaaaa&1&h&b
&212-250&2
&3orzyszu&3

Nagłówek wysłany do drukarki:
&b&h&1aaaaaaaaaaaaaaaaaaaa&h&b
&b&haaaaaaaaaaaaaaaaaaaa&1&h&b
&212-250&2
&3orzyszu&3

 */